import type {ReactNode} from 'react'
import {PullRequestState} from '../../../../types'
import {usePullRequestState} from '../../../../hooks/use-pull-request-state'
import {ClosedPR, shouldShowClosedPR} from '../pull-request-state/ClosedPR'
import {MergedPR, shouldShowMergedPR} from '../pull-request-state/MergedPR'

// The subscription states in the matrix need a dedicated For You component.
export function useVisitorDecider() {
  const pullRequestState = usePullRequestState()

  return getVisitorForYouAction({pullRequestState})
}

export function getVisitorForYouAction({pullRequestState}: {pullRequestState: PullRequestState}): ReactNode {
  if (shouldShowClosedPR(pullRequestState)) return <ClosedPR variant="embedded" userRole="visitor" />

  if (shouldShowMergedPR(pullRequestState)) return <MergedPR variant="embedded" userRole="visitor" />

  return null
}
